import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthServiceService } from './services/auth-service.service';
import { firstValueFrom } from 'rxjs';
import { HttpResponse } from '@angular/common/http';

export const guardsGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthServiceService);
  const router = inject(Router);

  try {
   
    const response: HttpResponse<any> = await firstValueFrom(authService.authService());

    
    if (response.status === 200) {
      return true;  // Autorizado a acessar a rota
    } else {
      router.navigate(['/adm']);  // Redireciona para a rota de login
      return false;  // Bloqueia a rota
    }
  return true;
  } catch (error) {
    router.navigate(['/adm']);  // Redireciona para a rota de login em caso de erro
    return false;  // Bloqueia a rota em caso de erro
  }
  
};
